<script setup lang="ts">
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import i18n from '@/plugins/i18n';
import { getLanguageOptions, setJunoLocale, type SupportedLocale } from '@/lib/junoLocale';
import useNotify from '@/composables/useNotify';

const { t, locale } = useI18n();
const router = useRouter();
const { notify } = useNotify();

const items = computed(() => getLanguageOptions(code => t(`languageSelector.names.${code}`)));
const isUpdating = ref(false);

async function onSelect(code: SupportedLocale) {
  if (isUpdating.value) return;
  isUpdating.value = true;
  try {
    await setJunoLocale(router, i18n, code);
  } catch (error) {
    notify(t('languageSelector.errors.updateFailed'), 'error');
    console.error('Failed to update Juno locale:', error);
  } finally {
    isUpdating.value = false;
  }
}
</script>

<template>
  <v-select
    class="juno-i18n-exclude juno-language-select"
    data-testid="juno-language-selector"
    density="compact"
    hide-details
    variant="outlined"
    rounded="lg"
    bg-color="white"
    prepend-inner-icon="mdi-earth"
    :aria-label="t('languageSelector.label')"
    :disabled="isUpdating"
    :items="items"
    item-title="title"
    item-value="value"
    :model-value="locale"
    @update:model-value="onSelect"></v-select>
</template>
